export const FIREBASE_REMOTE_CONFIG_FETCH_TIMEOUT = 1000 * 60;
export const FIREBASE_REMOTE_CONFIG_MIN_FETCH_INTERVAL = 1000 * 60 * 60;
